import {firstSteps} from "./help/first-steps";
import {searchDiscovery} from "./help/search-discovery";
import {collection} from "./help/collection";
import {reviews} from "./help/reviews";
import {marketplace} from "./help/marketplace";
import {shopsPrices} from "./help/shops-prices";
import {events} from "./help/events";
import {scheduledGames} from "./help/scheduled-games";
import {eventOperations} from "./help/event-operations";
import {eventTeam} from "./help/event-team";
import {playMatching} from "./help/play-matching";
import {tournaments} from "./help/tournaments";
import {locations} from "./help/locations";
import {ticketing} from "./help/ticketing";
import {liveSessions} from "./help/live-sessions";
import {gameKits} from "./help/game-kits";
import {playLogging} from "./help/play-logging";
import {statistics} from "./help/statistics";
import {replayBadges} from "./help/replay-badges";
import {campaigns} from "./help/campaigns";
import {aiGameAssistant} from "./help/ai-game-assistant";
import {groups} from "./help/groups";
import {organizations} from "./help/organizations";
import {clubConsole} from "./help/club-console";
import {membershipTiers} from "./help/membership-tiers";
import {socialFeeds} from "./help/social-feeds";
import {userProfiles} from "./help/user-profiles";
import {messaging} from "./help/messaging";
import {privacyVisibility} from "./help/privacy-visibility";
import {notifications} from "./help/notifications";
import {integrations} from "./help/integrations";
import {offlineSync} from "./help/offline-sync";
import {guidePlayers} from "./help/guide-players";
import {guideCollectors} from "./help/guide-collectors";
import {guideClubsOrganizers} from "./help/guide-clubs-organizers";
import {guideStoresVenues} from "./help/guide-stores-venues";
import {guideBringingYourClub} from "./help/guide-bringing-your-club";
import {publicApi} from "./help/public-api";
import {contact} from "./other/contact";

export type Page = {
    uri: string
    icon: string
    title: string
    /** Search-intent <title>/og:title; the short `title` stays on tiles, H1s and breadcrumbs. */
    seoTitle?: string
    summary: string
    markdownContent: string
}

export const allPages: Page[] = [
    firstSteps,
    searchDiscovery,
    collection,
    reviews,
    marketplace,
    shopsPrices,
    events,
    scheduledGames,
    tournaments,
    playMatching,
    eventOperations,
    eventTeam,
    ticketing,
    liveSessions,
    gameKits,
    playLogging,
    statistics,
    replayBadges,
    campaigns,
    aiGameAssistant,
    groups,
    organizations,
    clubConsole,
    membershipTiers,
    socialFeeds,
    userProfiles,
    messaging,
    privacyVisibility,
    locations,
    notifications,
    offlineSync,
    integrations,
    guidePlayers,
    guideCollectors,
    guideClubsOrganizers,
    guideBringingYourClub,
    guideStoresVenues,
    publicApi,
    contact
]
